import React from "react";
import Tooltip from "../tooltip/tooltip";
// onBlur är valfri. Använd den när ett värde måste klampas till ett minimum: om
// klampningen görs i onChange kan fältet aldrig tömmas eller skrivas över, eftersom
// mellanläget (tom sträng) omedelbart snappar tillbaka till minimivärdet.
const InputNumber = ({ title, value, onChange, onBlur, unit, className, disabled, tooltip, min, max, validationMessage }) => {

    const baseClassName = 'w-full rounded-xl p-2 pl-4 h-11 bg-airpark-gray-300 focus:outline-none';

    if (!className) {
        className = baseClassName;
    } else {
        className = `${baseClassName} ${className}`;
    }

    if (disabled) {
        className = `${baseClassName} opacity-50`;
    }

    return (
        <div>
            <div className="flex relative items-center">
                <span className="text-base font-medium pb-1">{title}</span>
                {tooltip &&
                    <Tooltip tooltip={tooltip} />
                }
            </div>
            <div className="relative">
                <input type="number" value={value ?? ''} min={min} max={max} onChange={(e) => { onChange(e.target.value); }} onBlur={onBlur ? (e) => { onBlur(e.target.value); } : undefined} autoComplete='off' autoCorrect='off' className={className} disabled={disabled ?? false} />
                {unit &&
                    <div className="flex absolute justify-center items-center right-0 top-0 h-11 min-w-[44px] pl-3 pr-3 rounded-lg bg-airpark-gray-400">
                        {unit}
                    </div>
                }
                {validationMessage && <div className="text-red-500 text-sm mt-1">{validationMessage}</div>}

            </div>
        </div>
    );
}

export default InputNumber;